// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 2K and 4K displays (large desktops, greater than 1200px) */
@media (min-width: 1200px) {
  /* Your CSS code for 2K and 4K displays goes here */
}
@media screen and (min-width: 1472px) and (min-height: 864px) {
  /* Your CSS code for the layout goes here */
}
.container-fluid,
.row-fluid {
  width: 100%;
  height: 100vh;
  display: flex;
  padding: 0;
  margin: 0;
}
.container-fluid .left-grid,
.row-fluid .left-grid {
  height: 100%;
  margin: 0;
  flex-grow: 1;
  background-color: #ffffff;
  border-right: 0.5px solid #acacac;
  overflow: visible;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  opacity: 1;
  visibility: visible;
  width: 100px;
  padding: 0;
  position: relative;
}
.container-fluid .left-grid.sidebar-closed,
.row-fluid .left-grid.sidebar-closed {
  width: 0px;
  min-width: 0;
  opacity: 0;
  flex-grow: 0;
  pointer-events: none;
}
.container-fluid .right-grid,
.row-fluid .right-grid {
  height: 100vh;
  flex-grow: 9;
  background-color: #ffffff;
  padding: 0;
  margin: 0;
  position: relative;
  margin-left: 0%;
  display: flex;
  flex-direction: column;
}

.main-container {
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 10px;
  background: rgba(1, 104, 191, 0.07);
}
.main-container .wrapper {
  width: 100%;
  background: #ffffff;
  border: 0.5px solid #acacac !important;
  border-radius: 24px;
  overflow: hidden;
  height: 100%;
  position: relative;
  padding-bottom: 0;
}
.main-container .wrapper > .content-layout {
  padding-top: 8px;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.main-container .wrapper > .content-layout .pi-times {
  position: absolute;
  width: 14px;
  height: 14px;
  right: 20px;
  top: 22px;
  cursor: pointer;
}
.main-container .wrapper > .content-layout .icon-items .filter-icon {
  cursor: pointer;
  color: #003da5;
  width: 14px;
  height: 19px;
  margin-top: 8px;
}
.main-container .wrapper > .content-layout .icon-items .add-new-design-intent-icon {
  cursor: pointer;
  color: #003da5;
  width: 18px;
  height: 18px;
  margin-top: 9px;
}
.main-container .wrapper > .content-layout .icon-items .add-new-design-intent-icon[disabled] {
  cursor: default;
}
.main-container .wrapper > .content-layout .icon-items .icon-label {
  font-size: 10px;
  color: #003da5;
  line-height: 13px;
  padding-top: 8px;
}
.main-container .wrapper > .content-layout .icon-items .p-checkbox + .icon-label {
  padding-top: 3px;
}
.main-container .wrapper > .content-layout .icon-items.disabled {
  pointer-events: none;
  opacity: 0.4;
}
.main-container .wrapper > .content-layout.task-layout {
  height: auto;
}
.main-container .wrapper.tab-wrapper {
  border: 0 !important;
  border-radius: 0;
}
.main-container .wrapper.tab-wrapper > .content-layout {
  background: rgba(1, 104, 191, 0.07);
  padding-top: 0;
}
.main-container .wrapper.tab-wrapper > .content-layout .tabular-view {
  position: relative;
  padding-bottom: 38px;
}
.main-container .wrapper.tab-wrapper > .content-layout .tabular-view .form-buttons {
  position: absolute;
  background: white;
  text-align: right;
  width: 100%;
  left: 0;
  bottom: 0;
}
.main-container .comon-wrapper {
  background: #edf4fa !important;
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/PageLayout/index.scss"],"names":[],"mappings":"AAAA,6DAAA;AACA;EACE,mDAAA;AACF;AAEA;EACE,2CAAA;AAAF;AAGA;;EAEE,WAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;AADF;AAGE;;EACE,YAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,iCAAA;EACA,iBAAA;EACA,yFAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAAJ;AAEI;;EACE,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;AACN;AAGE;;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mCAAA;AADF;AAGE;EACE,WAAA;EAEA,mBAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAFJ;AAII;EAEE,gBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,YAAA;AAJN;AAMM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAJR;AAQQ;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AANV;AASQ;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAPV;AASQ;EACE,eAAA;AAPV;AAUQ;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AARV;AAWQ;EACE,gBAAA;AATV;AAWQ;EACE,oBAAA;EACA,YAAA;AATV;AAaM;EACE,YAAA;AAXR;AAcI;EACE,oBAAA;EACA,gBAAA;AAZN;AAaM;EACE,mCAAA;EACA,cAAA;AAXR;AAYQ;EACE,kBAAA;EACA,oBAAA;AAVV;AAWU;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;AATZ;AAgBE;EACE,8BAAA;EACA,uBAAA;AAdJ","sourcesContent":["/* 2K and 4K displays (large desktops, greater than 1200px) */\n@media (min-width: 1200px) {\n  /* Your CSS code for 2K and 4K displays goes here */\n}\n\n@media screen and (min-width: 1472px) and (min-height: 864px) {\n  /* Your CSS code for the layout goes here */\n}\n\n.container-fluid,\n.row-fluid {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  padding: 0;\n  margin: 0;\n\n  .left-grid {\n    height: 100%;\n    margin: 0;\n    flex-grow: 1;\n    background-color: #ffffff;\n    border-right: 0.5px solid #acacac;\n    overflow: visible;\n    transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n    opacity: 1;\n    visibility: visible;\n    width: 100px;\n    padding: 0;\n    position: relative;\n\n    &.sidebar-closed {\n      width: 0px;\n      min-width: 0;\n      opacity: 0;\n      flex-grow: 0;\n      pointer-events: none;\n    }\n  }\n\n  .right-grid {\n    height: 100vh;\n    flex-grow: 9;\n    background-color: #ffffff;\n    padding: 0;\n    margin: 0;\n    position: relative;\n    margin-left: 0%;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.main-container {\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  background: rgba(1, 104, 191, 0.07);\n\n  .wrapper {\n    width: 100%;\n    // min-height: 100%;\n    background: #ffffff;\n    border: 0.5px solid #acacac !important;\n    border-radius: 24px;\n    overflow: hidden;\n    height: 100%;\n    position: relative;\n    padding-bottom: 0;\n\n    &>.content-layout {\n      // padding-top: 24px;\n      padding-top: 8px;\n      // padding-bottom: 32px;\n      position: relative;\n      overflow: hidden;\n      height: 100%;\n\n      .pi-times {\n        position: absolute;\n        width: 14px;\n        height: 14px;\n        right: 20px;\n        top: 22px;\n        cursor: pointer;\n      }\n\n      .icon-items {\n        .filter-icon {\n          cursor: pointer;\n          color: #003da5;\n          width: 14px;\n          height: 19px;\n          margin-top: 8px;\n        }\n\n        .add-new-design-intent-icon {\n          cursor: pointer;\n          color: #003da5;\n          width: 18px;\n          height: 18px;\n          margin-top: 9px;\n        }\n        .add-new-design-intent-icon[disabled]{\n          cursor: default;\n        }\n\n        .icon-label {\n          font-size: 10px;\n          color: #003da5;\n          line-height: 13px;\n          padding-top: 8px;\n        }\n\n        .p-checkbox+.icon-label {\n          padding-top: 3px;\n        }\n        &.disabled{\n          pointer-events: none;\n          opacity: 0.4;\n        }\n      }\n\n      &.task-layout {\n        height: auto;\n      }\n    }\n    &.tab-wrapper{\n      border: 0 !important;\n      border-radius: 0;\n      & > .content-layout{\n        background: rgba(1, 104, 191, 0.07);\n        padding-top: 0;\n        .tabular-view{\n          position: relative;\n          padding-bottom: 38px;\n          .form-buttons{\n            position: absolute;\n            background: white;\n            text-align: right;\n            width: 100%;\n            left: 0;\n            bottom: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .comon-wrapper {\n    background: #edf4fa !important;\n    border: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
